<div class="flex align-items-center gap-2">
  <span class="grey-text">Pratica</span>
  <h3 class="m-0">#{{ booking_identifier }}</h3>
</div>
@if (booking) {
<div class="mt-4">
  <p-tabView [(activeIndex)]="activeIndex">
    @if (!booking.travel.funding) {
    <p-tabPanel>
      @if (booking.travel.pricing_mode != 2) {
      <ng-template pTemplate="header">
        <i class="mobile pi pi-users"></i>
        <span class="screen">Stanze e partecipanti</span>
      </ng-template>
      <div class="rooms">
        <p-accordion [multiple]="true">
          <p-accordionTab [header]="getRoomHeader(t)" *ngFor="let t of booking.rooms; let last = last"
            [ngClass]="{ last: last }">
            <div *ngFor="let d of t.members" class="personal-info">
              <div class="grid">
                <div class="col-12 md:col-6">
                  <div class="flex flex-column gap-1">
                    <small class="grey-text">Partecipante:</small>
                    <span>{{ d.name }} {{ d.last_name }} ({{
                      d.gender
                      }})</span>
                  </div>
                </div>
                <div class="col-12 md:col-6">
                  <div class="flex flex-column gap-1">
                    <small class="grey-text">Disabile:</small>
                    @if (d.disabled === true) {
                    <i class="pi pi-check"></i>
                    } @else {
                    <i class="pi pi-times"></i>
                    }
                  </div>
                </div>
                <div class="col-12 md:col-6">
                  <div class="flex flex-column gap-1">
                    <small class="grey-text">Codice fiscale:</small>
                    <span>{{ d.fiscal_code }}</span>
                  </div>
                </div>
                <div class="col-12 md:col-6">
                  <div class="flex flex-column gap-1">
                    <small class="grey-text">Telefono:</small>
                    <span>{{ d.phone_number }}</span>
                  </div>
                </div>
                <div class="col-12 md:col-6">
                  <div class="flex flex-column gap-1">
                    <small class="grey-text">Email:</small>
                    <span>{{ d.email_address }}</span>
                  </div>
                </div>
                <div class="col-12 md:col-6">
                  <div class="flex flex-column gap-1">
                    <small class="grey-text">Data di nascita:</small>
                    <span>{{
                      d.date_of_birth | date: "dd/MM/yyyy"
                      }}</span>
                  </div>
                </div>
                <div class="col-12 md:col-6">
                  <div class="flex flex-column gap-1">
                    <small class="grey-text">Num. documento:</small>
                    <span>{{
                      d.document_type === "PT"
                      ? "Passaporto"
                      : "Carta d'identità"
                      }}
                      {{ d.document_number }}</span>
                  </div>
                </div>
                <div class="col-12 md:col-6">
                  <div class="flex flex-column gap-1">
                    <small class="grey-text">Scadenza documento:</small>
                    <span>{{
                      d.document_exp_date | date: "dd/MM/yyyy"
                      }}</span>
                  </div>
                </div>
                <div class="col-12 md:col-6">
                  <div class="flex flex-column gap-1">
                    <small class="grey-text">Data emissione documento:</small>
                    <span>{{
                      d.document_release_date | date: "dd/MM/yyyy"
                      }}</span>
                  </div>
                </div>
                <div class="col-12 md:col-6">
                  <div class="flex flex-column gap-1">
                    <small class="grey-text">Cittadinanza:</small>
                    <span>{{ d.nationality }}</span>
                  </div>
                </div>
              </div>
            </div>
          </p-accordionTab>
        </p-accordion>
      </div>
      } @else {
      <ng-template pTemplate="header">
        <i class="mobile pi pi-users"></i>
        <span class="screen">Pacchetti acquistati</span>
      </ng-template>
      <div class="rooms">
        <p-accordion [multiple]="true">
          <p-accordionTab [header]="getPackageHeader(t)" *ngFor="let t of booking.packages; let last = last"
            [ngClass]="{ last: last }">
            <div class="flex flex-column gap-2 bg-muted-t p-2 border-round-md mb-4">
              <div class="grey-text p-0 font-normal text-sm" [innerHTML]="t.travel_package.description"></div>
              <div class="flex align-items-center gap-1">
                <img src="/assets/media/icons/check-g.png" height="18" />
                <small>Ideato per
                  <b>{{ t.travel_package.n_partecipants }}</b> adult{{
                  t.travel_package.n_partecipants > 1 ? "i" : "o"
                  }}.</small>
              </div>
              <div class="flex align-items-center gap-1">
                <img src="/assets/media/icons/check-g.png" height="18" />
                <small>Numero massimo di bambini (2-8 anni) ammessi:
                  <b>{{ t.travel_package.max_n_children }}</b>.</small>
              </div>
              <div class="flex align-items-center gap-1">
                <img src="/assets/media/icons/check-g.png" height="18" />
                <small>Numero massimo di neonati (0-2 anni) ammessi:
                  <b>{{ t.travel_package.max_n_infants }}</b>.</small>
              </div>
              <div class="flex align-items-end justify-content-end gap-1">
                <small class="grey-text mb-1">Prezzo per numero minimo di adulti:</small>
                <h2 class="green m-0">
                  {{
                  t.travel_package.price_per_person
                  | currency: booking.travel.currency
                  }}
                </h2>
              </div>
            </div>
            <div *ngFor="let d of t.members" class="personal-info">
              <div class="grid">
                <div class="col-12 md:col-6">
                  <div class="flex flex-column gap-1">
                    <small class="grey-text">Partecipante:</small>
                    <span>{{ d.name }} {{ d.last_name }} ({{ d.member_type }}
                      {{ d.gender }})</span>
                  </div>
                </div>
                <div class="col-12 md:col-6">
                  <div class="flex flex-column gap-1">
                    <small class="grey-text">Disabile:</small>
                    @if (d.disabled === true) {
                    <i class="pi pi-check"></i>
                    } @else {
                    <i class="pi pi-times"></i>
                    }
                  </div>
                </div>
                <div class="col-12 md:col-6">
                  <div class="flex flex-column gap-1">
                    <small class="grey-text">Telefono:</small>
                    <span>{{ d.phone_number }}</span>
                  </div>
                </div>
                <div class="col-12 md:col-6">
                  <div class="flex flex-column gap-1">
                    <small class="grey-text">Email:</small>
                    <span>{{ d.email_address }}</span>
                  </div>
                </div>
                <div class="col-12 md:col-6">
                  <div class="flex flex-column gap-1">
                    <small class="grey-text">Data di nascita:</small>
                    <span>{{
                      d.date_of_birth | date: "dd/MM/yyyy"
                      }}</span>
                  </div>
                </div>
                <div class="col-12 md:col-6">
                  <div class="flex flex-column gap-1">
                    <small class="grey-text">Num. documento:</small>
                    <span>{{
                      d.document_type === "PT"
                      ? "Passaporto"
                      : "Carta d'identità"
                      }}
                      {{ d.document_number }}</span>
                  </div>
                </div>
                <div class="col-12 md:col-6">
                  <div class="flex flex-column gap-1">
                    <small class="grey-text">Scadenza documento:</small>
                    <span>{{
                      d.document_exp_date | date: "dd/MM/yyyy"
                      }}</span>
                  </div>
                </div>
                <div class="col-12 md:col-6">
                  <div class="flex flex-column gap-1">
                    <small class="grey-text">Data emissione documento:</small>
                    <span>{{
                      d.document_release_date | date: "dd/MM/yyyy"
                      }}</span>
                  </div>
                </div>
                <div class="col-12 md:col-6">
                  <div class="flex flex-column gap-1">
                    <small class="grey-text">Cittadinanza:</small>
                    <span>{{ d.nationality }}</span>
                  </div>
                </div>
              </div>
            </div>
            @if (t.notes) {
            <div class="bg-muted-o p-3 border-round-md mt-3">
              <small class="grey-text">Note:</small>
              <div class="mt-2" [innerHTML]="t.notes"></div>
            </div>
            }
          </p-accordionTab>
        </p-accordion>
      </div>
      }
    </p-tabPanel>
    }
    <p-tabPanel>
      <ng-template pTemplate="header">
        <i class="mobile pi pi-credit-card"></i>
        <span class="screen">Pagamenti</span>
      </ng-template>
      <div class="rooms">
        <div class="table-container">
          <p-table [value]="booking.payments">
            <ng-template pTemplate="header">
              <tr>
                <th></th>
                <th>Importo</th>
                <th>Costi di servizio</th>
                <th>Scadenza</th>
                <th>Stato</th>
                <th>Data di pagamento</th>
                <th>Metodo di pagamento</th>
                <th></th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-p let-i="rowIndex">
              <!-- {{p.amount}} -->

              <tr [formGroup]="frmPayment">
                <td class="surface-100 font-bold">
                  @if (p.type | isAdvance) {
                  <div>Acconto</div>
                  } @else {
                  <div>Saldo</div>
                  }
                </td>
                <!-- <td>
                  @if (booking.travel.customer_pays_fees ) {
                  <div class="flex align-items-center gap-1">
                    {{
                    p.amount | currency: p.currency : "symbol" : ".2-2"
                    }}
                  </div>
                  <div class="flex align-items-center gap-1 text-xs grey-text">
                    (Costi di servizio esclusi)
                  </div>
                  } @else {
                  <div class="flex align-items-center gap-1">
                    {{
                    p.amount | currency: p.currency : "symbol" : ".2-2"
                    }}


                  </div>
                  }
                </td> -->
                <!-- <td>
                  @if (booking.travel.customer_pays_fees ) {

                  <div class="flex align-items-center gap-1">
                    {{
                    p.amount * 0.03
                    | currency: p.currency : "symbol" : ".0-2"
                    }}
                  </div>
                  } @else {
                  <div class="flex align-items-center gap-1">-</div>
                  }
                </td> -->
                <!-- costi -->
                <td>
                  {{
                  p.amount | currency: p.currency : "symbol" : ".2-2"
                  }}
                </td>
                <td>
                  @if (booking.travel.customer_pays_fees) {
                  <div class="flex align-items-center gap-1">
                    {{
                    p.amount - p.amount / 1.03
                    | currency: p.currency : "symbol" : ".2-2"
                    }}
                  </div>
                  } @else {
                  <div class="flex align-items-center gap-1">
                    {{
                    p.amount * 0.03
                    | currency: p.currency : "symbol" : ".2-2"
                    }}
                  </div>
                  }
                </td>
                <td>{{ p.expires_on | date: "dd/MM/yyyy" }}</td>

                <td>
                  <div [innerHTML]="p.status.id | paymentStatus"></div>
                </td>
                <td>
                  @if (
                  p.type === enumPaymentMethod.BANK_TRANSFER_ADV ||
                  p.type === enumPaymentMethod.BANK_TRANSFER_PAYOFF
                  ) {
                  <p-calendar formControlName="date" styleClass="w-full" dateFormat="dd/mm/yy" appendTo="body"
                    panelStyleClass="custom-calendar" [touchUI]="false" [firstDayOfWeek]="1"></p-calendar>
                  } @else {
                  <span>{{ p.payed_on | date: "dd/MM/yyyy" }}</span>
                  }
                </td>

                <td>
                  <div class="flex" [innerHTML]="p.type | paymentMethod"></div>
                </td>
                <td>
                  @if (
                  (p.type === enumPaymentMethod.CASH_ADV ||
                  p.type === enumPaymentMethod.CASH_PAYOFF) &&
                  p.status.id != enumPaymentStatus.PAYED
                  ) {
                  <p-button label="Registra pagamento" size="small" styleClass="slide-o"
                    (click)="registerBankTransfer(p.identifier)"></p-button>
                  }
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </p-tabPanel>
    <p-tabPanel header="Informazioni aggiuntive">
      <ng-template pTemplate="header">
        <i class="mobile pi pi-info-circle"></i>
        <span class="screen">Informazioni aggiuntive</span>
      </ng-template>
      <div class="rooms">
        <div class="table-container">
          <h4>Dati <span class="green">intestatario</span></h4>
          <div class="grid">
            <div class="col-6">
              <div class="flex flex-column gap-1">
                <small class="grey-text">Nome</small>
                <span>{{ booking.accountholder_name | titlecase}}
                  {{ booking.accountholder_last_name | titlecase}}</span>
              </div>
            </div>
            <div class="col-6">
              <div class="flex flex-column gap-1">
                <small class="grey-text">Codice fiscale</small>
                <span>{{ booking.accountholder_fiscal_code || "-" }}</span>
              </div>
            </div>
            <div class="col-6">
              <div class="flex flex-column gap-1">
                <small class="grey-text">Paese</small>
                <span>{{ booking.accountholder_country_iso }}</span>
              </div>
            </div>
            <div class="col-6">
              <div class="flex flex-column gap-1">
                <small class="grey-text">Indirizzo</small>
                <span>{{ booking.accountholder_address }}</span>
              </div>
            </div>
            <div class="col-6">
              <div class="flex flex-column gap-1">
                <small class="grey-text">CAP</small>
                <span>{{ booking.accountholder_zip_code }}</span>
              </div>
            </div>
            <div class="col-6">
              <div class="flex flex-column gap-1">
                <small class="grey-text">Città</small>
                <span>{{ booking.accountholder_city }},
                  {{ booking.accountholder_province }}</span>
              </div>
            </div>

            <div class="col-6">
              <div class="flex flex-column gap-1">
                <small class="grey-text">Contatti</small>
                <div class="flex align-items-center gap-2">
                  <i class="pi pi-phone grey-text text-sm"></i>
                  <span>{{ booking.accountholder_mobile_phone }}</span>
                </div>
                <div class="flex align-items-center gap-2">
                  <i class="pi pi-envelope grey-text text-sm"></i>
                  <span>{{ booking.accountholder_email }}</span>
                </div>
              </div>
            </div>
          </div>

          <hr>
          <div class="col-6">
            <div class="flex flex-column gap-1">
              <small class="grey-text">Allergie segnalate</small>
              @if (booking.packages && booking.packages.length) {
              @for (pkg of booking.packages; track pkg.id) {
              <span>{{ (pkg.allergies | titlecase )|| '-' }}</span>
              }
              }



            </div>
          </div>
          <hr>
          <h4>Volo e <span class="yellow">acquisti</span></h4>
          <div class="grid">

            <div class="col-6">
              <div class="flex flex-column gap-1">
                <small class="grey-text">Servizi aggiuntivi</small>
                @for (s of booking.addl_services; track $index) {
                <div class="flex align-items-end gap-1">
                  <b>{{ s.title }}</b>
                  <h4 class="green m-0">
                    {{
                    s.price
                    | currency
                    : booking.travel.currency
                    : "symbol"
                    : ".0-0"
                    }}
                  </h4>
                  @if (s.qty) {
                  <small> Aquistato x{{ s.qty }} </small>
                  } @else {
                  <small>Non acquistato</small>
                  }
                </div>
                }
              </div>
            </div>
            <div class="col-6">
              <div class="flex flex-column gap-1">
                <small class="grey-text">Assicurazioni</small>
                @for (s of booking.addl_insurances; track $index) {
                <div class="flex align-items-end gap-1">
                  <b>{{ (s.title | titlecase) || '-'}}</b>
                  <h4 class="green m-0">
                    {{
                    s.price
                    | currency
                    : booking.travel.currency
                    : "symbol"
                    : ".0-0"
                    }}
                  </h4>
                  @if (s.qty) {
                  <small> Aquistato x{{ s.qty }} </small>
                  } @else {
                  <small>Non acquistato</small>
                  }
                </div>
                }
              </div>
            </div>
            @if (booking.travel.optional_flight_purchase) {
            <div class="col-6">
              <div class="flex flex-column gap-1">
                <small class="grey-text">Volo</small>
                @if (booking.with_flights) {
                <span>Viaggio acquistato senza preferenze sul volo</span>
                } @else {
                <span>Viaggio acquistato senza volo</span>
                }
              </div>
            </div>
            }
          </div>
        </div>
      </div>
    </p-tabPanel>
  </p-tabView>
</div>
}

<div class="modal-footer flex justify-content-end">
  <!-- <div class="red">
        <p-button label="Elimina prenotazione" size="small" [outlined]="true" styleClass="px-6" (click)="confirmDelete(booking_identifier!)"></p-button>
    </div> -->
  <div>
    <p-button label="Chiudi" size="small" [outlined]="true" styleClass="px-6" (click)="close()"></p-button>
  </div>
  <div class="red">
    <p-button [text]="true" size="small" styleClass="px-6 ml-1" icon="pi pi-trash"
      (click)="confirmDelete(booking!.identifier)"></p-button>
  </div>
</div>